import netsNav from './nets-nav';

export default angular
  .module('app.nav', [])
  .component('netsNav', netsNav);
